<div class="upload-container">
  <form>
    <div class="drop-area"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)"
         *ngIf="!config?.viewOnly && ((config?.limit > files.length) || !config?.limit)"
         [class.dragging]="isDragging">
      <ion-button class="page-button" (click)="fileInput.click()" color="secondary">{{'WORK_NOTES.Upload' | translate}}</ion-button>
      <span>{{'WORK_NOTES.DD' | translate}}</span>

      <input type="file" [accept]="config.accept" (change)="onFileSelected($event)" #fileInput hidden />
    </div>

    <div *ngIf="files.length" class="file-list">
      <div class="file-item" *ngFor="let file of files; let i = index">
        <div class="file-item-container">
          <ng-container *ngIf="file.status === UploadFileStatus.Done || config.deferredUpload">
            <img *ngIf="file.icon && !file.preview" (click)="open(file)" [src]="file.icon" class="image-preview" />
            <img *ngIf="file.preview" [src]="file.preview" (click)="open(file)" class="image-preview" />
          </ng-container>

          <div *ngIf="!config?.viewOnly" class="file-header">
            <span class="file-name">{{ file?.data?.name }}</span>
            <span (click)="removeFile(i)" class="file-remove-icon"></span>
          </div>
        </div>

        <ion-progress-bar [value]="file.progress / 100"
                          *ngIf="file.progress !== null && file.status !== UploadFileStatus.Done"
                          class="progress-bar"
                          color="success"></ion-progress-bar>

        <div *ngIf="file.status === UploadFileStatus.Error" class="error-msg">
          ❌ {{ file.error }}
          <ion-button (click)="uploadFile(file)" *ngIf="!config.deferredUpload" class="page-button retry-btn" color="light">{{"SHARED.Try_Again" | translate}}</ion-button>
        </div>
      </div>
    </div>
  </form>
</div>
